export default {
  title: 'Provider di consegna',
};
